<template>
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item
      v-for="(item, index) in navData"
      class="row"
      :key="index"
    >
      <span class="word" @click="goPath(item)">{{item.title}}</span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'index',
  props: {
    navData: Array
  },
  methods: {
    goPath (item) {
      const { path, detailInfo } = item
      if (detailInfo) {
        return this.$emit('onDetailInfo')
      }
      window.open(`/#${path}`, '_self')
      window.location.reload()
    }
  }
}
</script>

<style lang="less" scoped>
  .row{
    &:last-child{
      .word {
        color: #666;
        cursor: pointer;
      }
    }

    .word {
      cursor: pointer;

      &:hover{
        color: #006ed1;
      }
    }
  }
</style>
